export default {"src":"/_next/static/media/football_yellow_red.0004ec72.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};